import { isGroceriesOrSimilar } from 'constants/productTypes';
import { getProductById } from 'redux/modules/entities/selectors/products';

export const groceriesItemInTrolley = state => {
  const myTrolleyItems = state.trolley.trolleyItems
    .filter(trolleyItem => trolleyItem.quantity?.amount !== 0)
    .map(trolleyItem =>
      isGroceriesOrSimilar((getProductById(state, trolleyItem.productId) || {}).productType),
    );

  return myTrolleyItems.some(groceryItem => groceryItem === true);
};
